import { m as globalThis_1 } from './index-f674799c.js';

var path = globalThis_1;

export { path as p };
